import styles from './CreateObservation.module.scss';
import addObservationIcon from 'client/assets/imgs/add_observations.svg';
import addObservationIconInverted from 'client/assets/imgs/add_observations_inverted.svg';
import { useSelector, useDispatch } from 'react-redux';
import { mapMenuTabKeys, mapModes } from 'client/utils/constants/appStates';
import { useIntl } from 'react-intl';
import MapControl from 'client/pages/MapPage/components/MapControl/MapControl';
import { setAlertProps } from 'client/store/alertSlice/alertSlice';
import { addMapMode, removeMapMode } from 'client/store/mapSlice/mapSlice';
import { useHasUserPermission } from 'client/utils/auth/userPermissions';
import { permissions } from 'client/utils/constants/permissions';
import Button from 'client/components/aria/Button/Button';
import { ProgressCircle } from 'client/components/aria/Loading';

const CreateObservationButton = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const mapMode = useSelector(state => state.map?.mode || []);
    const selectedTab = useSelector(state => state?.map?.menuSelectedTab);
    const hasPermission = useHasUserPermission(permissions.OBSERVATIONS_CREATE);

    const visible = hasPermission && selectedTab !== mapMenuTabKeys.ENHANCED_MEASURES && !mapMode.includes(mapModes.MODIFYING);

    const isAddingObservation = mapMode.includes(mapModes.ADDING_OBSERVATION);

    const startCreateObservationFlow = () => {
        if (!mapMode.includes(mapModes.AOI)) {
            dispatch(setAlertProps({
                open: true,
                severity: 'warning',
                content: intl.formatMessage({ id: 'createObservation.noAOIDefined' })
            }));
            return;
        }
        if (isAddingObservation) {
            dispatch(removeMapMode(mapModes.ADDING_OBSERVATION));
        } else {
            dispatch(addMapMode(mapModes.ADDING_OBSERVATION));
        }
    };

    return <MapControl>
        {visible && <div className={styles.container}>
            <Button
                className={[isAddingObservation ? styles.active : ''].join(' ')}
                isDisabled={mapMode.includes(mapModes.LOADING)}
                onPress={startCreateObservationFlow}
                data-testid={'createObservation'}
                variant='secondary'
                aria-label={intl.formatMessage({ id: 'createObservation.altText' })}
            >
                {mapMode.includes(mapModes.LOADING)
                    ? <ProgressCircle
                        data-testid={'createObservation.progress'}
                        isIndeterminate
                        size={24}
                    />
                    : <img
                        src={isAddingObservation
                            ? addObservationIconInverted
                            : addObservationIcon}
                        alt={''} width={19} height={19} />
                }
            </Button>
        </div>}
    </MapControl>;
};

export default CreateObservationButton;
